module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "finance"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "2rem"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.authorizeVersapay()
      }
    }
  }, [_vm._v("Pay My Tuition")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Invoices")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-998916c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Finance.vue
// module id = 2110
// module chunks = 2